import {createContext} from 'react';

export const SceneContext = createContext(null);
